import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";

const API = "https://api.ctexpresskh.com/api";

export default function Settings() {
  const [settings, setSettings] = useState({
    company_name: "", company_tel: "", company_address: "",
    company_logo: "", label_width: "80", label_height: "100", telegram_link: "",
    label_footer_1: "", label_footer_2: ""
  });
  const [loading, setLoading] = useState(false);
  const [preview, setPreview] = useState(false);
  const token = localStorage.getItem("token");

  useEffect(() => {
    fetch(API + "/settings", { headers: { Authorization: "Bearer " + token } })
      .then(r => r.json()).then(d => { if (d.data) setSettings(s => ({ ...s, ...d.data })); });
  }, []);

  const save = async () => {
    setLoading(true);
    try {
      const res = await fetch(API + "/settings", {
        method: "PUT",
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
        body: JSON.stringify({ settings })
      });
      const data = await res.json();
      if (data.success) toast.success("Settings saved!");
      else toast.error(data.message);
    } catch { toast.error("Error saving"); }
    setLoading(false);
  };

  const handleLogo = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > 2000000) { toast.error("Logo must be under 2MB"); return; }
    const formData = new FormData();
    formData.append('logo', file);
    try {
      const res = await fetch(API + "/settings/upload-logo", {
        method: "POST",
        headers: { Authorization: "Bearer " + token },
        body: formData
      });
      const data = await res.json();
      if (data.success) {
        setSettings(s => ({ ...s, company_logo: data.url }));
        toast.success("Logo uploaded!");
      } else toast.error(data.message || "Upload failed");
    } catch { toast.error("Upload error"); }
  };

  const inp = (label, key, placeholder="", type="text") => (
    <div style={{ marginBottom: 18 }}>
      <label style={{ display: "block", marginBottom: 6, fontSize: 13, fontWeight: 600, color: "#374151" }}>{label}</label>
      <input type={type} value={settings[key] || ""} onChange={e => setSettings(s => ({ ...s, [key]: e.target.value }))}
        placeholder={placeholder}
        style={{ width: "100%", padding: "10px 14px", border: "1px solid #d1d5db", borderRadius: 8, fontSize: 14, boxSizing: "border-box" }} />
    </div>
  );

  const sampleShipment = {
    tracking_number: "YT7614817977060",
    receiver_name: "PHOK Srey Pov",
    receiver_phone: "098882246",
    receiver_address: "Phnom Penh",
    goods_description: "Sample Goods",
    quantity: 1, weight_kg: 1.5, shipping_fee: 1.28,
    length_cm: 20, width_cm: 15, height_cm: 10, cbm: "0.003",
    created_at: new Date().toISOString()
  };

  return (
    <div style={{ padding: 32 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 28 }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 24, color: "#1e293b" }}>Company Settings</h1>
          <p style={{ margin: "4px 0 0", color: "#64748b", fontSize: 14 }}>Configure company info and shipping label</p>
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          <button onClick={() => setPreview(!preview)}
            style={{ padding: "10px 20px", border: "2px solid #f97316", color: "#f97316", background: "#fff", borderRadius: 8, cursor: "pointer", fontWeight: 600 }}>
            {preview ? "Hide Preview" : "Preview Label"}
          </button>
          <button onClick={save} disabled={loading}
            style={{ padding: "10px 24px", background: "#f97316", color: "#fff", border: "none", borderRadius: 8, cursor: "pointer", fontWeight: 700, opacity: loading ? 0.7 : 1 }}>
            {loading ? "Saving..." : "Save Settings"}
          </button>
        </div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: preview ? "1fr 1fr" : "1fr", gap: 24 }}>
        <div>
          {/* Company Info */}
          <div style={{ background: "#fff", borderRadius: 12, padding: 24, boxShadow: "0 1px 4px rgba(0,0,0,0.08)", marginBottom: 20 }}>
            <h3 style={{ margin: "0 0 20px", color: "#f97316", fontSize: 16 }}>Company Information</h3>
            {inp("Company Name", "company_name", "CT EXPRESS")}
            {inp("Phone / Tel", "company_tel", "85581768752")}
            {inp("Address", "company_address", "Phnom Penh, Cambodia")}
            <div style={{ marginBottom: 18 }}>
              <label style={{ display: "block", marginBottom: 6, fontSize: 13, fontWeight: 600, color: "#374151" }}>Company Logo</label>
              <input type="file" accept="image/*" onChange={handleLogo} style={{ marginBottom: 10 }} />
              {settings.company_logo && (
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  <img src={settings.company_logo} alt="Logo" style={{ width: 80, height: 80, objectFit: "contain", border: "1px solid #e2e8f0", borderRadius: 8 }} />
                  <button onClick={() => setSettings(s => ({ ...s, company_logo: "" }))}
                    style={{ padding: "6px 12px", background: "#fee2e2", color: "#dc2626", border: "none", borderRadius: 6, cursor: "pointer", fontSize: 13 }}>
                    Remove Logo
                  </button>
                </div>
              )}
            </div>
          </div>

          {/* Label Settings */}
          <div style={{ background: "#fff", borderRadius: 12, padding: 24, boxShadow: "0 1px 4px rgba(0,0,0,0.08)", marginBottom: 20 }}>
            <h3 style={{ margin: "0 0 20px", color: "#f97316", fontSize: 16 }}>Label Size</h3>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
              <div>
                <label style={{ display: "block", marginBottom: 6, fontSize: 13, fontWeight: 600, color: "#374151" }}>Width (mm)</label>
                <input type="number" value={settings.label_width || "80"} onChange={e => setSettings(s => ({ ...s, label_width: e.target.value }))}
                  style={{ width: "100%", padding: "10px 14px", border: "1px solid #d1d5db", borderRadius: 8, fontSize: 14, boxSizing: "border-box" }} />
              </div>
              <div>
                <label style={{ display: "block", marginBottom: 6, fontSize: 13, fontWeight: 600, color: "#374151" }}>Height (mm)</label>
                <input type="number" value={settings.label_height || "100"} onChange={e => setSettings(s => ({ ...s, label_height: e.target.value }))}
                  style={{ width: "100%", padding: "10px 14px", border: "1px solid #d1d5db", borderRadius: 8, fontSize: 14, boxSizing: "border-box" }} />
              </div>
            </div>
            <div style={{ marginTop: 12, padding: 10, background: "#f8fafc", borderRadius: 8, fontSize: 12, color: "#64748b" }}>
              Current size: <strong>{settings.label_width}mm × {settings.label_height}mm</strong>
            </div>
          </div>

          {/* CN Warehouse Info */}
          <div style={{ background: "#fff", borderRadius: 12, padding: 24, boxShadow: "0 1px 4px rgba(0,0,0,0.08)", marginBottom: 20 }}>
            <h3 style={{ margin: "0 0 20px", color: "#f97316", fontSize: 16 }}>China Warehouse Info</h3>
            <p style={{ fontSize: 12, color: "#64748b", marginBottom: 16 }}>This info is shown to customers on the mobile app for easy copy.</p>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16}}>
              <div><h4 style={{color:'#dc2626',marginBottom:12}}>🚛 Land</h4>
                {inp("Receiver Name (收货人)", "cn_land_receiver", "")}
                {inp("Phone (手机号码)", "cn_land_phone", "")}
                {inp("Region (所在地区)", "cn_land_region", "")}
                {inp("Address (详细地址)", "cn_land_address", "")}
                {inp("Label Prefix", "cn_land_label", "CAM-L")}
              </div>
              <div><h4 style={{color:'#1d4ed8',marginBottom:12}}>🚢 Sea</h4>
                {inp("Receiver Name (收货人)", "cn_sea_receiver", "")}
                {inp("Phone (手机号码)", "cn_sea_phone", "")}
                {inp("Region (所在地区)", "cn_sea_region", "")}
                {inp("Address (详细地址)", "cn_sea_address", "")}
                {inp("Label Prefix", "cn_sea_label", "CAM-S")}
              </div>
            </div>
            <div style={{marginTop:16}}><h4 style={{color:'#7c3aed',marginBottom:12}}>✈️ Air</h4>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16}}>
                <div>
                  {inp("Receiver Name (收货人)", "cn_air_receiver", "")}
                  {inp("Phone (手机号码)", "cn_air_phone", "")}
                </div>
                <div>
                  {inp("Region (所在地区)", "cn_air_region", "")}
                  {inp("Address (详细地址)", "cn_air_address", "")}
                  {inp("Label Prefix", "cn_air_label", "CAM-A")}
                </div>
              </div>
            </div>
          </div>

          {/* Footer Text */}
          <div style={{ background: "#fff", borderRadius: 12, padding: 24, boxShadow: "0 1px 4px rgba(0,0,0,0.08)" }}>
            <h3 style={{ margin: "0 0 20px", color: "#f97316", fontSize: 16 }}>Label Footer Text</h3>
            {inp("Footer Line 1 (Khmer/Chinese)", "label_footer_1", "សូមពិនិត្យទំនិញ មុននឹងចុះហត្ថលេខាទទួលទំនិញ!")}
            {inp("Footer Line 2 (Khmer/Chinese)", "label_footer_2", "វិវាទនឹងមិនត្រូវបានទទួលយក បន្ទាប់ពីចុះហត្ថលេខារួចហើយ!")}
            {inp("📱 Telegram Link (shown on KH WH shipments)", "telegram_link", "https://t.me/yourchannel")}
            <div style={{ marginTop: 24, padding: 16, background: '#fff7ed', borderRadius: 8, border: '1px solid #fed7aa' }}>
              <div style={{ fontWeight: 700, fontSize: 14, color: '#92400e', marginBottom: 12 }}>📱 Mobile App Version Control</div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div>
                  <label style={{ fontSize: 12, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 4 }}>Min Version (force update below this)</label>
                  <input value={settings.app_min_version || '1.0.0'} onChange={e => setSettings(s => ({ ...s, app_min_version: e.target.value }))}
                    placeholder="1.0.0" style={{ width: '100%', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }} />
                </div>
                <div>
                  <label style={{ fontSize: 12, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 4 }}>Latest Version</label>
                  <input value={settings.app_latest_version || '1.0.0'} onChange={e => setSettings(s => ({ ...s, app_latest_version: e.target.value }))}
                    placeholder="1.0.0" style={{ width: '100%', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }} />
                </div>
                <div>
                  <label style={{ fontSize: 12, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 4 }}>Force Update Message</label>
                  <input value={settings.app_update_message || 'Please update to continue'} onChange={e => setSettings(s => ({ ...s, app_update_message: e.target.value }))}
                    placeholder="Please update to continue" style={{ width: '100%', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }} />
                </div>
                <div>
                  <label style={{ fontSize: 12, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 4 }}>Store URL (Play Store / App Store)</label>
                  <input value={settings.app_store_url || ''} onChange={e => setSettings(s => ({ ...s, app_store_url: e.target.value }))}
                    placeholder="https://play.google.com/store/apps/..." style={{ width: '100%', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }} />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Label Preview */}
        {preview && (
          <div>
            <div style={{ background: "#fff", borderRadius: 12, padding: 24, boxShadow: "0 1px 4px rgba(0,0,0,0.08)", position: "sticky", top: 20 }}>
              <h3 style={{ margin: "0 0 16px", color: "#1e293b", fontSize: 16 }}>Label Preview ({settings.label_width}×{settings.label_height}mm)</h3>
              <LabelPreview settings={settings} shipment={sampleShipment} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function LabelPreview({ settings, shipment }) {
  const date = new Date(shipment.created_at).toLocaleDateString("en-GB");
  const w = settings.label_width || 80;
  const h = settings.label_height || 100;
  const scale = Math.min(400 / (w * 3.78), 500 / (h * 3.78));

  return (
    <div style={{ overflow: "auto" }}>
      <div style={{
        width: w * 3.78 + "px", height: h * 3.78 + "px",
        border: "2px solid #000", fontFamily: "Arial, sans-serif",
        fontSize: "11px", transform: "scale(" + scale + ")", transformOrigin: "top left",
        boxSizing: "border-box", background: "#fff"
      }}>
        {/* Header */}
        <div style={{ display: "flex", alignItems: "center", borderBottom: "2px solid #000", padding: "6px 8px", gap: 8 }}>
          {settings.company_logo
            ? <img src={settings.company_logo} alt="logo" style={{ width: 50, height: 50, objectFit: "contain" }} />
            : <div style={{ fontSize: 20, fontWeight: 900, border: "2px solid #000", padding: "2px 5px", fontFamily: "serif" }}>T<span style={{color:"#e00"}}>F</span><br/>EXPRESS</div>
          }
          <div>
            <div style={{ fontSize: 16, fontWeight: 900, letterSpacing: 2 }}>{settings.company_name || "CT EXPRESS"}</div>
            <div style={{ fontSize: 9, color: "#333" }}>电话/ Tel: {settings.company_tel}</div>
            <div style={{ fontSize: 9, color: "#333" }}>地址 /Address: {settings.company_address}</div>
          </div>
        </div>
        {/* Date */}
        <div style={{ textAlign: "center", fontWeight: "bold", fontSize: 13, padding: "4px", borderBottom: "1px solid #000" }}>Date: {date}</div>
        {/* Receiver Info */}
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 10 }}>
          <tbody>
            <tr><td style={{ padding: "3px 6px", color: "#555", width: 90 }}>收件人/ Name:</td><td style={{ padding: "3px 6px", fontWeight: 700 }}>{shipment.receiver_name}</td></tr>
            <tr><td style={{ padding: "3px 6px", color: "#555" }}>电话/ Tel :</td><td style={{ padding: "3px 6px" }}>{shipment.receiver_phone}</td></tr>
            <tr><td style={{ padding: "3px 6px", color: "#555" }}>地址/ Addr:</td><td style={{ padding: "3px 6px" }}>{shipment.receiver_address}</td></tr>
          </tbody>
        </table>
        {/* CBM/Qty/Weight */}
        <table style={{ width: "100%", borderCollapse: "collapse", borderTop: "1px solid #000", fontSize: 10 }}>
          <tbody>
            <tr style={{ borderBottom: "1px solid #ccc" }}>
              <td style={{ padding: "3px 6px" }}><div style={{ color: "#555", fontSize: 9 }}>立方/CBM:</div><div>{shipment.length_cm}x{shipment.width_cm}x{shipment.height_cm} {shipment.cbm}m³</div></td>
            </tr>
            <tr style={{ borderBottom: "1px solid #ccc" }}>
              <td style={{ padding: "3px 6px" }}><div style={{ color: "#555", fontSize: 9 }}>数量/Qty:</div><div>{shipment.quantity}</div></td>
            </tr>
            <tr>
              <td style={{ padding: "3px 6px" }}><div style={{ color: "#555", fontSize: 9 }}>毛重/G.W.(KG):</div><div>{shipment.weight_kg}</div></td>
            </tr>
          </tbody>
        </table>
        {/* Fee */}
        <div style={{ textAlign: "center", borderTop: "1px solid #000", padding: "4px", fontSize: 10 }}>
          <div style={{ color: "#555" }}>运费/Shipping Cost($):</div>
          <div style={{ fontSize: 16, fontWeight: "bold" }}>{parseFloat(shipment.shipping_fee).toFixed(2)}</div>
        </div>
        {/* Tracking */}
        <div style={{ borderTop: "2px solid #000", padding: "6px", textAlign: "center" }}>
          <div style={{ fontWeight: 900, fontSize: 13, marginBottom: 4 }}>跟踪号码 /Tracking Number</div>
          <div style={{ fontFamily: "monospace", fontSize: 28, letterSpacing: 3, fontWeight: 900, borderTop: "1px solid #eee", borderBottom: "1px solid #eee", padding: "4px 0" }}>
            |||||||||||||||||||||||
          </div>
          <div style={{ fontWeight: "bold", fontSize: 11, marginTop: 2 }}>{shipment.tracking_number}</div>
        </div>
        {/* Footer */}
        <div style={{ borderTop: "1px solid #000", padding: "4px 6px", fontSize: 9, color: "#333" }}>
          <div>-{settings.label_footer_1}</div>
          <div>-{settings.label_footer_2}</div>
        </div>
      </div>
    </div>
  );
}
